import styled from 'styled-components';
import BannerBackground from '../../../public/assets/images/common/offers_counter_bg.webp';
import CountdownTimer from './CountdownTimer';
import { useTranslation } from 'next-i18next';
import useCountdownTimer from '../../../hooks/CountdownTimer';
import ImageWrapper from '../../../new-components/ImageWrapper';
import ExclusiveBannerIcon from '../../../new-components/svg-icons/ExclusiveBannerIcon';

interface CountdownBannerProps {
  endDate: any;
}
const CountdownBanner = ({ endDate }: CountdownBannerProps) => {
  const { t } = useTranslation(['cityscape']);
  const { countdownTime } = useCountdownTimer(endDate);

  if (
    countdownTime.hasEnded ||
    (!countdownTime.days &&
      !countdownTime.hours &&
      !countdownTime.minutes &&
      !countdownTime.seconds)
  ) {
    return <></>;
  }

  return (
    <Banner className="offers-banner">
      <ImageWrapper
        src={BannerBackground}
        alt="Offers Banner"
        fill
        style={{ borderRadius: '12px', objectFit: 'cover' }}
        imageSize={'medium'}
        withSkeleton
      />
      <div className="banner-info">
        <ExclusiveBannerIcon />
        <div className="separator" />
        <span className="countdown-start">{t('starts_in')}</span>
      </div>
      <div className="banner-info">
        <CountdownTimer endDate={endDate} />
      </div>
    </Banner>
  );
};

const Banner = styled.div`
  position: relative;
  width: 380px;
  height: 65px;
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  gap: 8px;
  border-radius: 12px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);

  .banner-info {
    z-index: 99;
    display: flex;
    align-items: center;
    color: white;
    .separator {
      width: 1px;
      height: 28px;
      background: #d1d4d9;
      margin: 0px 8px;
    }
    .countdown-start {
      color: #fff;
      font-family: materialBold;
      font-size: 17px;
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    width: 90%;
  }
`;

export default CountdownBanner;
